import React, { useState, useEffect } from "react";
import Sidebar from "./components/Sidebar";
import TicketsView from "./modules/ops/screens/TicketsView";
import CMDBView from "./modules/ops/screens/CMDBView";
import DiscoveryView from "./modules/admin/screens/DiscoveryView";
import KnowledgeBaseView from "./modules/ops/screens/KnowledgeBaseView";
import AnalyticsView from "./modules/ops/screens/AnalyticsView";
import LoginView from "./modules/ops/screens/LoginView";
import Icon from "./components/Icon";
import { clearAuth, getStoredAuth } from "./api";
import NetworkView from "./modules/ops/screens/NetworkView";
import DemoConsoleModal from "./components/DemoConsoleModal";

export default function App() {
  const isAdminPath = window.location.pathname === "/admin";

  const [activeView, setActiveView] = useState(() =>
    isAdminPath ? "discovery" : "tickets",
  );
  const [auth, setAuth] = useState(() => getStoredAuth());
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isDemoConsoleOpen, setIsDemoConsoleOpen] = useState(false);

  const [standardNav] = useState([
    { id: "tickets", label: "Tickets", icon: "ticket" },
    { id: "cmdb", label: "CMDB", icon: "database" },
    { id: "network", label: "Network Infrastructure", icon: "network" },
    { id: "knowledge", label: "Knowledge Base", icon: "book" },
    { id: "analytics", label: "Analytics", icon: "activity" },
  ]);

  const [adminNav] = useState([
    {
      id: "discovery",
      label: "Discovery",
      icon: "globe",
      desc: "Scan subnets & deploy agents",
    },
  ]);

  useEffect(() => {
    setActiveView(isAdminPath ? "discovery" : "tickets");
  }, [isAdminPath]);

  function handleLogin(authResponse) {
    setAuth(authResponse);
    if (window.location.pathname !== "/admin") {
      window.history.replaceState(null, "", "/");
    }
  }

  function handleLogout() {
    clearAuth();
    setAuth(null);
    window.history.replaceState(null, "", "/login");
  }

  return (
    <div className="app-layout-container">
      {!auth ? (
        <LoginView onLogin={handleLogin} />
      ) : (
        <>
          {/* Mobile Header Bar */}
          <div className="mobile-top-bar">
            <button
              onClick={() => setIsMobileSidebarOpen(true)}
              className="mobile-hamburger-btn"
              title="Open Navigation"
            >
              <Icon name="menu" size={20} />
            </button>
            <div className="mobile-app-title">
              <Icon name="zap" size={15} color="#1D4ED8" />
              <span>AIOps</span>
            </div>
            <div style={{ width: 32 }}></div>
          </div>

          {/* Drawer backdrop overlay for mobile */}
          <div
            className={`sidebar-backdrop ${isMobileSidebarOpen ? "mobile-open" : ""}`}
            onClick={() => setIsMobileSidebarOpen(false)}
          />

          <Sidebar
            activeView={activeView}
            setActiveView={setActiveView}
            onLogout={handleLogout}
            onOpenDemoConsole={() => setIsDemoConsoleOpen(true)}
            isMobileOpen={isMobileSidebarOpen}
            onCloseMobile={() => setIsMobileSidebarOpen(false)}
            nav={isAdminPath ? adminNav : standardNav}
            isAdminPath={isAdminPath}
          />

          {isAdminPath ? (
            <>{activeView === "discovery" && <DiscoveryView />}</>
          ) : (
            <>
              {activeView === "tickets" && <TicketsView />}
              {activeView === "cmdb" && <CMDBView />}
              {activeView === "network" && <NetworkView />}
              {activeView === "knowledge" && <KnowledgeBaseView />}
              {activeView === "analytics" && <AnalyticsView />}
            </>
          )}

          <DemoConsoleModal
            isOpen={isDemoConsoleOpen}
            onClose={() => setIsDemoConsoleOpen(false)}
          />
        </>
      )}
    </div>
  );
}
